<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div class="bookmarks-container">
    <ul class="bookmarks-list">
      <li
        v-for="(bookmark, index) in bookmarks"
        :key="index"
        @click="navigateTo(bookmark)"
        class="bookmark-item"
      >
        <i
          :class="
            bookmark.type === 'folder' ? 'ri-folder-line' : 'ri-file-line'
          "
          class="bookmark-icon"
        ></i>
        <span class="bookmark-name">
          {{ bookmark.name }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "BookmarksComponent",
  props: {
    bookmarks: {
      type: Array,
      default: () => [],
    },
    urlResolver: {
      type: Function,
      default: null,
    },
  },
  methods: {
    navigateTo(bookmark) {
      if (this.urlResolver) {
        this.urlResolver(bookmark);
      }
    },
  },
};
</script>

<style scoped>
.bookmarks-container {
  width: 100%;
}

.bookmarks-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.bookmark-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition:
    background-color 0.2s,
    color 0.2s;
}

.bookmark-item:hover {
  background: var(--p-highlight-background);
  color: var(--p-primary-color);
}

.bookmark-icon {
  font-size: 1.125rem;
  flex-shrink: 0;
  color: var(--p-primary-color);
}

.bookmark-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}
</style>
